import { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import axios from 'axios';

import useTranslation from 'Hooks/useTranslation';

import 'scss/components/content/account.scss';
import 'scss/components/content/_account-register.scss';
import 'scss/components/content/_error-messages.scss';

export default function AccountRegister() {

	const { blogUrl, ajaxUrl, ajaxNonce } = window.appConfig;

	const navigate = useNavigate();

	const { t } = useTranslation();

	const [submitting, setSubmitting] = useState(false);
	const [successful, setSuccessful] = useState(false);
	const [error, setError] = useState(false);

	const registerForm = useRef(null)

	const handleSubmit = event => {
		event.preventDefault();
		setError( null );
		setSubmitting(true);
		let data = new FormData( registerForm.current );

		data.append('action', 'register_account');
		data.append('nonce', ajaxNonce );

		axios.post( ajaxUrl, data )
		.then(function (response) {
			setSubmitting(false);
			setSuccessful(true);
			navigate( '/account-register-welcome', { trigger: true } );
		})
		.catch(function (error) {
			setSubmitting(false);
			setSuccessful(false);
			let message = '';
			if (error.response) {
				message += error.response.data.data;
			} else if (error.request) {

				message += error.request;
			} else {
				message += error.message;
			}
			setError( error.message + "\n" + message );
		});

	}
	return (

<div id='account-page' className='account-register'>

	<h3 className='title'>{ t('newRegistration') }</h3>
	<form className='account-register__form' onSubmit={handleSubmit} ref={registerForm} >
		<input type="hidden" name="action" value="create_account" />
		<div className="columns_left">
			<fieldset>
				<select name="gender" aria-required="false" aria-invalid="false" >
					<option value="">Anrede</option>
					<option value="Frau">Frau</option>
					<option value="Herr">Herr</option>
				</select>
			</fieldset>
		</div>
		<div className="columns_2 columns_left">
			<fieldset>
				<input required type="text" name="firstName" aria-required="true" aria-invalid="false" placeholder="Vorname *" />
			</fieldset>
		</div>
		<div className="columns_2">
			<fieldset>
				<input required type="text" name="lastName" aria-required="true" aria-invalid="false" placeholder="Nachname *" />
			</fieldset>
		</div>
		<div className="columns_2 columns_left">
			<fieldset>
				<select required name="status" aria-required="true" aria-invalid="false"  >
					<option value="">Ich bin *</option>
					<option value="Fest angestellt">Fest angestellt</option>
					<option value="Freiberuflich tätig">Freiberuflich tätig</option>
				</select>
			</fieldset>
		</div>
		<div className="columns_2">
			<fieldset>
			<input required type="text" name="medium" aria-required="true" aria-invalid="false" placeholder="Medium / Organisation / Institution *"/>
			</fieldset>
		</div>
		<div className="columns_2 columns_left">
			<fieldset>
				<input type="text" name="redaction" aria-invalid="false" placeholder="Redaktion / Ressort / Fachgebiet"/>
			</fieldset>
		</div>

		<div className="columns_2">
			<fieldset>
				<input type="text" name="twitter" aria-required="false" aria-invalid="false" placeholder="Twitter"/>
			</fieldset>
		</div>

		<div className="columns_2 columns_left">
			<fieldset>
				<select required name="country" aria-required="true" aria-invalid="false">
					<option value="">Land *</option>
					<option value="DE">Deutschland</option>
					<option value="AT">Österreich</option>
					<option value="CH">Schweiz</option>
					<option value="LU">Luxemburg</option>
					<option value="AF">Afghanistan</option>
					<option value="EG">Ägypten</option>
					<option value="AX">Åland</option>
					<option value="AL">Albanien</option>
					<option value="DZ">Algerien</option>
					<option value="AS">Amerikanisch-Samoa</option>
					<option value="AD">Andorra</option>
					<option value="AO">Angola</option>
					<option value="AI">Anguilla</option>
					<option value="AQ">Antarktis</option>
					<option value="AG">Antigua/Barbuda</option>
					<option value="GQ">Äquatorialguinea</option>
					<option value="AR">Argentinien</option>
					<option value="AM">Armenien</option>
					<option value="AW">Aruba</option>
					<option value="AZ">Aserbaidschan</option>
					<option value="ET">Äthiopien</option>
					<option value="AU">Australien</option>
					<option value="BS">Bahamas</option>
					<option value="BH">Bahrain</option>
					<option value="BD">Bangladesh</option>
					<option value="BB">Barbados</option>
					<option value="BE">Belgien</option>
					<option value="BZ">Belize</option>
					<option value="BJ">Benin</option>
					<option value="BM">Bermuda</option>
					<option value="BT">Bhutan</option>
					<option value="BO">Bolivien</option>
					<option value="BA">Bosnien/Herzegowina</option>
					<option value="BW">Botsuana</option>
					<option value="BV">Bouvetinsel</option>
					<option value="BR">Brasilien</option>
					<option value="BN">Brunei Darussalam</option>
					<option value="BG">Bulgarien</option>
					<option value="BF">Burkina Faso</option>
					<option value="BI">Burundi</option>
					<option value="CV">Cabo Verde</option>
					<option value="CL">Chile</option>
					<option value="CN">China</option>
					<option value="CK">Cookinseln</option>
					<option value="CR">Costa Rica</option>
					<option value="CU">Cuba</option>
					<option value="DM">Dominica</option>
					<option value="DO">Dominikanische Republik</option>
					<option value="DJ">Dschibuti</option>
					<option value="DK">Dänemark</option>
					<option value="EC">Ecuador</option>
					<option value="SV">El Salvador</option>
					<option value="CI">Elfenbeinküste</option>
					<option value="ER">Eritrea</option>
					<option value="EE">Estland</option>
					<option value="FK">Falklandinseln</option>
					<option value="FJ">Fidschi</option>
					<option value="FI">Finnland</option>
					<option value="FR">Frankreich</option>
					<option value="GF">Französisch-Guayana</option>
					<option value="PF">Französisch-Polynesien</option>
					<option value="TF">Französische Südpolarterritorien</option>
					<option value="FO">Färöer</option>
					<option value="GA">Gabun</option>
					<option value="GM">Gambia</option>
					<option value="GE">Georgien</option>
					<option value="GH">Ghana</option>
					<option value="GI">Gibraltar</option>
					<option value="GD">Grenada</option>
					<option value="GR">Griechenland</option>
					<option value="GB">Großbritannien</option>
					<option value="GL">Grönland</option>
					<option value="GP">Guadeloupe</option>
					<option value="GU">Guam</option>
					<option value="GT">Guatemala</option>
					<option value="GG">Guernsey</option>
					<option value="GW">Guinea-Bissau</option>
					<option value="GN">Guinea</option>
					<option value="GY">Guyana</option>
					<option value="HT">Haiti</option>
					<option value="HM">Heard und McDonaldinseln</option>
					<option value="HN">Honduras</option>
					<option value="HK">Hong Kong</option>
					<option value="IN">Indien</option>
					<option value="ID">Indonesien</option>
					<option value="IQ">Irak</option>
					<option value="IR">Iran</option>
					<option value="IE">Irland</option>
					<option value="IS">Island</option>
					<option value="IM">Isle Of Man</option>
					<option value="IL">Israel</option>
					<option value="IT">Italien</option>
					<option value="JM">Jamaika</option>
					<option value="JP">Japan</option>
					<option value="YE">Jemen</option>
					<option value="JE">Jersey</option>
					<option value="JO">Jordanien</option>
					<option value="VI">Jungferninseln, Amerikanische</option>
					<option value="VG">Jungferninseln, Britische</option>
					<option value="KY">Kaimaninseln</option>
					<option value="KH">Kambodscha</option>
					<option value="CM">Kamerun</option>
					<option value="CA">Kanada</option>
					<option value="KZ">Kasachstan</option>
					<option value="KE">Kenia</option>
					<option value="KG">Kirgisistan</option>
					<option value="KI">Kiribati</option>
					<option value="CC">Kokosinseln</option>
					<option value="CO">Kolumbien</option>
					<option value="KM">Komoren</option>
					<option value="CG">Kongo</option>
					<option value="HR">Kroatien</option>
					<option value="KW">Kuwait</option>
					<option value="LA">Laos</option>
					<option value="LS">Lesotho</option>
					<option value="LV">Lettland</option>
					<option value="LB">Libanon</option>
					<option value="LR">Liberia</option>
					<option value="LY">Libyen</option>
					<option value="LI">Liechtenstein</option>
					<option value="LT">Litauen</option>
					<option value="MO">Macao</option>
					<option value="MG">Madagaskar</option>
					<option value="MW">Malawi</option>
					<option value="MY">Malaysia</option>
					<option value="MV">Maldiven</option>
					<option value="ML">Mali</option>
					<option value="MT">Malta</option>
					<option value="MH">Marshallinseln</option>
					<option value="MQ">Martinique</option>
					<option value="MR">Mauretanien</option>
					<option value="MU">Mauritius</option>
					<option value="YT">Mayotte</option>
					<option value="MK">Mazedonien</option>
					<option value="MX">Mexiko</option>
					<option value="FM">Mikronesien</option>
					<option value="MD">Moldawien</option>
					<option value="MC">Monaco</option>
					<option value="MN">Mongolei</option>
					<option value="ME">Montenegro</option>
					<option value="MS">Montserrat</option>
					<option value="MA">Morokko</option>
					<option value="MZ">Mosambik</option>
					<option value="MM">Myanmar</option>
					<option value="NA">Namibia</option>
					<option value="NR">Nauru</option>
					<option value="NP">Nepal</option>
					<option value="NC">Neukaledonien</option>
					<option value="NZ">Neuseeland</option>
					<option value="NI">Nicaragua</option>
					<option value="NL">Niederlande</option>
					<option value="AN">Niederländische Antillen</option>
					<option value="NG">Nigeria</option>
					<option value="NE">Niger</option>
					<option value="NU">Niue</option>
					<option value="KP">Nordkorea</option>
					<option value="NF">Norfolkinsel</option>
					<option value="NO">Norwegen</option>
					<option value="MP">Nördliche Marianen</option>
					<option value="OM">Oman</option>
					<option value="PK">Pakistan</option>
					<option value="PW">Palau</option>
					<option value="PS">Palestina</option>
					<option value="PA">Panama</option>
					<option value="PG">Papua-Neuguinea</option>
					<option value="PY">Paraguay</option>
					<option value="PE">Peru</option>
					<option value="PH">Philippinen</option>
					<option value="PN">Pitcairninseln</option>
					<option value="PL">Polen</option>
					<option value="PT">Portugal</option>
					<option value="PR">Puerto Rico</option>
					<option value="QA">Qatar</option>
					<option value="RW">Ruanda</option>
					<option value="RO">Rumänien</option>
					<option value="RU">Russland</option>
					<option value="RE">Réunion</option>
					<option value="SB">Salomonen</option>
					<option value="ZM">Sambia</option>
					<option value="WS">Samoa</option>
					<option value="SM">San Marino</option>
					<option value="SA">Saudi-Arabien</option>
					<option value="SE">Schweden</option>
					<option value="SN">Senegal</option>
					<option value="RS">Serbien</option>
					<option value="SC">Seychellen</option>
					<option value="SL">Sierra Leone</option>
					<option value="ZW">Simbabwe</option>
					<option value="SG">Singapur</option>
					<option value="SK">Slowakische Republik</option>
					<option value="SI">Slowenien</option>
					<option value="SO">Somalia</option>
					<option value="ES">Spanien</option>
					<option value="LK">Sri Lanka</option>
					<option value="BL">St. Barthélemy</option>
					<option value="SH">St. Helena</option>
					<option value="KN">St. Kitts/Nevis</option>
					<option value="LC">St. Lucia</option>
					<option value="MF">St. Martin</option>
					<option value="PM">St. Pierre/Miquelon</option>
					<option value="VC">St. Vincent/Die Grenadinen</option>
					<option value="SD">Sudan</option>
					<option value="SR">Surinam</option>
					<option value="SJ">Svalbard/Jan Mayen</option>
					<option value="SZ">Swasiland</option>
					<option value="SY">Syrien</option>
					<option value="ST">São Tomé/Príncipe</option>
					<option value="ZA">Südafrika</option>
					<option value="GS">Südgeorgien/Südlichen Sandwichinseln</option>
					<option value="KR">Südkorea</option>
					<option value="TJ">Tadschikistan</option>
					<option value="TW">Taiwan</option>
					<option value="TZ">Tansania</option>
					<option value="TH">Thailand</option>
					<option value="TL">Timor-Leste</option>
					<option value="TG">Togo</option>
					<option value="TK">Tokelau</option>
					<option value="TO">Tonga</option>
					<option value="TT">Trinidad und Tobago</option>
					<option value="TD">Tschad</option>
					<option value="CZ">Tschechoslowakei</option>
					<option value="TN">Tunisien</option>
					<option value="TM">Turkmenistan</option>
					<option value="TC">Turks- und Caicosinseln</option>
					<option value="TV">Tuvalu</option>
					<option value="TR">Türkei</option>
					<option value="UG">Uganda</option>
					<option value="UA">Ukraine</option>
					<option value="HU">Ungarn</option>
					<option value="UM">United States Minor Islands</option>
					<option value="UY">Uruguay</option>
					<option value="US">USA</option>
					<option value="UZ">Usbekistan</option>
					<option value="VU">Vanuatu</option>
					<option value="VA">Vatikanstadt</option>
					<option value="VE">Venezuela</option>
					<option value="AE">Vereinigte Arabische Emirate</option>
					<option value="VN">Vietnam</option>
					<option value="WF">Wallis/Futuna</option>
					<option value="CX">Weihnachtsinsel</option>
					<option value="BY">Weißrussland</option>
					<option value="EH">Westsahara</option>
					<option value="CF">Zentralafrikanische Republik</option>
					<option value="CY">Zypern</option>
				</select>
			</fieldset>
		</div>

		<div className="columns_2">
			<fieldset>
				<input required type="text" name="city" aria-required="true" aria-invalid="false" placeholder="Ort *"/>
			</fieldset>
		</div>
		<div className="columns_2 columns_left">
			<fieldset>
				<input required type="text" name="zipCode" aria-required="true" aria-invalid="false" placeholder="Postleitzahl *"/>
			</fieldset>
		</div>
		<div className="columns_2">
			<fieldset>
				<input required type="text" name="street" aria-required="true" aria-invalid="false" placeholder="Straße und Hausnummer *"/>
			</fieldset>
		</div>


		<div className="columns_2 columns_left">
			<fieldset>
				<input required type="email" name="email" aria-required="true" aria-invalid="false" placeholder="E-Mail-Adresse *"/>
			</fieldset>
		</div>

		<div className="columns_2">
			<fieldset>
				<input type="text" name="phone" aria-required="false" aria-invalid="false" placeholder="Telefon"/>
			</fieldset>
		</div>
		<div className="columns_2 columns_left">
			<fieldset>
				<input required type="password" name="password" aria-required="true" aria-invalid="false" placeholder="Passwort *"/>
			</fieldset>
		</div>
		<div className="columns_2 ">
			<fieldset>
				<input required type="password" name="passwordConfirmation" aria-required="true" aria-invalid="false" placeholder="Passwort bestätigen *"/>
			</fieldset>
		</div>
		<div className="columns_1">
			<fieldset>
				<label>
					<input required type="checkbox" className='cgu-checkbox' aria-required="true" name="cgu-checkbox" value="1" aria-invalid="false"/>
					{ t('account.register.acceptConditions') } <a href={ blogUrl + 'files/allgemeine-nutzungsbedingungen.pdf' } target="_blank">{ t('account.register.termsAndCondtions') }</a>

				</label>
			</fieldset>
		</div>

		<div className="columns_right submit">
			<button type="submit" disabled={submitting}>{ t( 'account.register.submit') }</button>
		</div>
	</form>
	{submitting &&
		<div>
			Submitting...
		</div>
	}
	{successful &&
		<div>
			Submission successful.
		</div>
	}
	{ error && <div className='error-messages'>{ error }</div>}

</div>
	);
};
